import { getModelVersionESSForProject } from '@/domain/impact/utils/get-model-version-for-project';
import { runImpactCalculateFestivalEssForProject } from '@/domain/impact-calculate-festival/actions/run-impact-calculate-festival-ess-for-project.action';
import { runImpactCalculateTourEssForProject } from '@/domain/impact-calculate-tour/actions/run-impact-calculate-tour-ess-for-project.action';
import { runImpactCalculateVenueEssForDate } from '@/domain/impact-calculate-venue/actions/run-impact-calculate-venue-ess-for-date.action';
import { runImpactCalculateVenueEssForProject } from '@/domain/impact-calculate-venue/actions/run-impact-calculate-venue-ess-for-project.action.ts';
import { getImpactEssResponses } from '@/domain/impact-ess/actions/get-impact-ess-responses.action';
import { EssQuestionValue } from '@/domain/impact-ess/entities/question.entity';
import { ModelVersionESS } from '@/domain/project/entities/project.entity';
import {
  selectCurrentProject,
  selectCurrentProjectMode,
} from '@/domain/project/project.selectors';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { selectImpactEssResponses } from '../impact-ess.selectors';

type Params = {
  projectId: number;
  response: EssQuestionValue;
  essModelVersion?: ModelVersionESS;
};

export const submitImpactEssResponse = createAppAsyncThunk(
  'impactEss/submitImpactEssResponse',
  async (
    { projectId, response, essModelVersion }: Params,
    { extra: { impactEssGateway, snackbarGateway }, dispatch, getState },
  ) => {
    try {
      const { submitMode, answerIdToEdit } = defineSubmitMode(
        selectImpactEssResponses(getState()),
        response,
      );
      const currentProject = selectCurrentProject(getState());
      const projectMode = selectCurrentProjectMode(getState());
      const modelVersion = getModelVersionESSForProject(
        projectMode,
        currentProject,
      );
      switch (submitMode) {
        case 'create':
          await impactEssGateway.createImpactEssResponse(
            projectId,
            response.paramId,
            response.value,
            essModelVersion || modelVersion,
          );
          break;
        case 'edit':
          await impactEssGateway.editImpactEssResponse(
            answerIdToEdit,
            response.value,
          );
          break;
      }
      dispatch(getImpactEssResponses({ projectId }));
      if (projectMode === 'festival' && !essModelVersion) {
        dispatch(runImpactCalculateFestivalEssForProject({ projectId }));
      }
      if (projectMode === 'venue' && !essModelVersion) {
        dispatch(runImpactCalculateVenueEssForProject({ projectId }));
      }
      if (essModelVersion && currentProject) {
        // TODO  bug ici non ? on dirait que ce code est executer meme si on est pas sur une date
        dispatch(
          runImpactCalculateVenueEssForDate({
            dateId: projectId,
            projectId: currentProject.id,
          }),
        );
      }
      if (projectMode === 'tour') {
        dispatch(runImpactCalculateTourEssForProject({ projectId }));
      }
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function defineSubmitMode(
  responses: EssQuestionValue[],
  answerToSubmit: EssQuestionValue,
): { submitMode: 'create' | 'edit'; answerIdToEdit: number } {
  const item = responses.find((x) => x.paramId === answerToSubmit.paramId);
  if (item) {
    return { submitMode: 'edit', answerIdToEdit: item.id };
  } else {
    return { submitMode: 'create', answerIdToEdit: -1 };
  }
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('SubmitImpactAnswer.Message.error'));
}
